import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},


	{
		path: '/',
		name: 'Home',
		redirect: '/home',
	},
	{
		path: '/home',
		name: '總覽',
		layout: "custom",
		id: 'ENT_DASHBOARD_LIST',
		component: () => import('../views/admin/Home.vue'),
	},
	// 品牌
	{
		path: '/mch',
		name: '品牌經營',
		layout: "custom",
		id: "ENT_MCH_LIST",
		component: () => import('../views/admin/Mch/List.vue'),
	},
	{
		path: '/mch/add',
		name: '品牌經營-創建',
		layout: "custom",
		id: "ENT_MCH_ADD",
		component: () => import('../views/admin/Mch/AddOrEdit.vue'),
	},
	{
		path: '/mch/edit/:id',
		name: '品牌經營-修正',
		layout: "custom",
		id: "ENT_MCH_EDIT",
		component: () => import('../views/admin/Mch/AddOrEdit.vue'),
	},
	// 場館管理
	{
		path: '/gymnasium',
		name: '場館管理',
		layout: "custom",
		id: "ENT_VENUES_LIST",
		component: () => import('../views/admin/Gymnasium/Manage.vue'),
	},
	{
		path: '/gymnasium/form',
		name: '場館管理-添加',
		layout: "custom",
		id: "ENT_VENUES_ADD",
		component: () => import('../views/admin/Gymnasium/Form.vue')
	},
	{
		path: '/gymnasium/form/:id',
		name: '場館管理-修改',
		layout: "custom",
		id: "ENT_VENUES_UPDATE",
		component: () => import('../views/admin/Gymnasium/Form.vue')
	},
	{
		path: '/gymnasium/:id',
		name: '場館管理-詳情',
		layout: "custom",
		id: "ENT_VENUES_VIEW",
		component: () => import('../views/admin/Gymnasium/Details.vue')
	},

	{
		path: '/stadium',
		name: '場地管理',
		layout: "custom",
		id: "ENT_PLAYING_FIELD_LIST",
		component: () => import('../views/admin/Stadium/Manage.vue'),
	},
	{
		path: '/stadium/form',
		name: '場地管理-添加',
		layout: "custom",
		id: "ENT_PLAYING_FIELD_ADD",
		component: () => import('../views/admin/Stadium/Form.vue')
	},
	{
		path: '/stadium/form/:id',
		name: '場地管理-修改',
		layout: "custom",
		id: "ENT_PLAYING_FIELD_UPDATE",
		component: () => import('../views/admin/Stadium/Form.vue')
	},
	{
		path: '/stadium/:id',
		name: '場地管理-詳情',
		layout: "custom",
		id: "ENT_PLAYING_FIELD_VIEW",
		component: () => import('../views/admin/Stadium/Details.vue')
	},



	{
		path: '/matches-timeslot',
		name: '場次時段記錄',
		layout: "custom",
		id: "ENT_TIMESLOT_LIST",
		component: () => import('../views/admin/MatchesTimeSlot/Manage.vue'),
	},
	{
		path: '/matches-timeslot/form',
		name: '場次時段記錄-添加',
		layout: "custom",
		id: "ENT_TIMESLOT_ADD",
		component: () => import('../views/admin/MatchesTimeSlot/Form.vue'),
	},
	{
		path: '/matches-timeslot/form/:id',
		name: '場次時段記錄-編輯',
		layout: "custom",
		id: "ENT_TIMESLOT_UPDATE",

		component: () => import('../views/admin/MatchesTimeSlot/Edit.vue'),
	},


	{
		path: '/matches-calendar',
		name: '場次表排定管理',
		layout: "custom",
		id: "ENT_MATCHES_CALENDAR",
		component: () => import('../views/admin/MatchesCalendar/Manage.vue'),
	},

	{
		path: '/product',
		name: '產品管理',
		layout: "custom",
		id: "ENT_SERVICE_LIST",
		component: () => import('../views/admin/Product/Manage.vue'),
	},
	{
		path: '/product/form',
		name: '產品管理-添加',
		layout: "custom",
		id:"ENT_SERVICE_ADD",
		component: () => import('../views/admin/Product/Form.vue'),
	},
	{
		path: '/product/form/:id',
		name: '產品管理-編輯',
		layout: "custom",
		id: "ENT_SERVICE_UPDATE",
		component: () => import('../views/admin/Product/Edit.vue'),
	},
	{
		path: '/product/:id',
		name: '產品管理-詳情',
		layout: "custom",
		id: "ENT_SERVICE_VIEW",
		component: () => import('../views/admin/Product/Details.vue'),
	},
	{
		path: '/sakes',
		name: '銷售管理',
		layout: "custom",
		component: () => import('../views/admin/Ticket/Sales.vue'),
	},


	//安全與權限管理
	{
		path: '/security',
		name: '賬號管理',
		redirect: '/security/account',
	},
	//系統帳號管理
	{
		path: '/security/account',
		name: '賬號管理',
		layout: "custom",
		id:"ENT_UR_USER",
		component: () => import('../views/admin/System/Security/Account.vue'),
	},
	{
		path: '/security/account/form',
		name: '賬號管理-添加',
		layout: "custom",
		id:"ENT_UR_USER_ADD",
		component: () => import('../views/admin/System/Security/Form.vue'),
	},
	{
		path: '/security/account/form/:id',
		name: '賬號管理-編輯',
		layout: "custom",
		id: "ENT_UR_USER_UPDATE",
		component: () => import('../views/admin/System/Security/Form.vue'),
	},
	{
		path: '/security/account/role/:id',
		name: '賬號管理-編輯角色',
		layout: "custom",
		id:"ENT_UR_ROLE_UPDATE",
		component: () => import('../views/admin/System/Security/AccountRoleForm.vue'),
	},
	{
		path: '/security/role',
		name: '角色管理',
		layout: "custom",
		id:"ENT_UR_ROLE",
		component: () => import('../views/admin/System/Security/Role/Manage.vue'),
	},
	{
		path: '/security/role/form',
		name: '角色管理-添加',
		layout: "custom",
		id: "ENT_UR_ROLE_ADD",
		component: () => import('../views/admin/System/Security/Role/Form.vue'),
	},
	{
		path: '/security/role/form/:id',
		name: '角色管理-編輯',
		layout: "custom",
		id: "ENT_UR_ROLE_EDIT",
		component: () => import('../views/admin/System/Security/Role/Form.vue'),
	},
	{
		path: '/permission',
		name: '權限管理',
		layout: "custom",
		id: "ENT_UR_ROLE_ENT",
		component: () => import('../views/admin/System/Security/Permission/Manage.vue'),
	},
	//
	{
		path: '/sign-in',
		name: 'Sign-In',
		component: () => import('../views/Sign-In.vue'),
	},



	// 活動管理
	{
		path: '/activity',
		name: '品牌活動',
		layout: "custom",
		id: "ENT_BRAND_ACTIVITY_LIST",
		component: () => import('../views/admin/Activity/List.vue'),
	},
	{
		path: '/activity/add',
		name: '品牌活動-添加',
		layout: "custom",
		id: "ENT_BRAND_ACTIVITY_ADD",
		component: () => import('../views/admin/Activity/AddOrEdit.vue')
	},
	{
		path: '/activity/edit/:id',
		name: '品牌活動-修改',
		layout: "custom",
		id: "ENT_BRAND_ACTIVITY_UPDATE",
		component: () => import('../views/admin/Activity/AddOrEdit.vue')
	},
	//發票
	{
		path: '/invoice',
		name: '發票管理',
		layout: "custom",
		id: "ENT_INVOICE_LIST",
		component: () => import('../views/admin/Invoice/List.vue'),
	},
	//廣告 banner
	{
		path: '/ad',
		name: '輪播圖',
		layout: "custom",
		id: "ENT_ADVERTISEMENT_LIST",
		component: () => import('../views/admin/Advertisement/List.vue'),
	},
	{
		path: '/ad/add',
		name: '輪播圖-添加',
		layout: "custom",
		id: "ENT_ADVERTISEMENT_ADD",
		component: () => import('../views/admin/Advertisement/AddOrEdit.vue')
	},
	{
		path: '/ad/edit/:id',
		name: '輪播圖-修改',
		layout: "custom",
		id: "ENT_ADVERTISEMENT_UPDATE",
		component: () => import('../views/admin/Advertisement/AddOrEdit.vue')
	},
	//訂單管理
	{
		path: '/order/list',
		name: '票卷管理',
		layout: "custom",
		id: "ENT_TICKET_ORDER_LIST",
		component: () => import('../views/admin/Order/List.vue'),
	},
	
	{
		path: '/order/group',
		name: '票卷管理-票卷分類',
		layout: "custom",
		id: "ENT_ORDER_GROUP_LIST",
		component: () => import('../views/admin/OrderGroup/List.vue'),
	},
	{
		path: '/order/today',
		name: '票卷管理-今日報道',
		layout: "custom",
		id: "ENT_TICKET_ORDER_CHECKED_LIST",
		component: () => import('../views/admin/OrderToDay/List.vue'),
	},
	{
		path: '/order/uncheck',
		name: '票卷管理-待核銷列表',
		layout: "custom",
		id: "ENT_TICKET_ORDER_UNCHECK_LIST",
		component: () => import('../views/admin/OrderUncheck/List.vue'),
	},
	// {
	// 	path: '/order/uncheck/add',
	// 	name: '票卷管理-訂單核銷',
	// 	layout: "custom",
	// 	id: "ENT_ORDER_UNCHECK_ADD",
	// 	component: () => import('../views/admin/OrderUncheck/AddOrEdit.vue'),
	// },

	{
		path: '/order/transfer',
		name: '票卷管理-轉讓訂單',
		layout: "custom",
		id: "ENT_TICKET_TRANSFER_ORDER_LIST",
		component: () => import('../views/admin/OrderTransfer/List.vue'),
	},

	// 客戶管理
	{
		path: '/member/list',
		name: '客戶管理',
		layout: "custom",
		id: "ENT_MEMBER_LIST",
		component: () => import('../views/admin/Member/List.vue'),
	},
	{
		path: '/member/add',
		name: '客戶管理-添加',
		layout: "custom",
		id: "ENT_MEMBER_ADD",
		component: () => import('../views/admin/Member/AddOrEdit.vue')
	},
	{
		path: '/member/edit/:id',
		name: '客戶管理-修改',
		layout: "custom",
		id: "ENT_MEMBER_EDIT",
		component: () => import('../views/admin/Member/AddOrEdit.vue')
	},
	{
		path: '/member/account-record',
		name: '會員管理-點數',
		id: "ENT_MEMBER_POINT_LOGS_LIST",
		layout: "custom",
		component: () => import('../views/admin/MemberAccountRecord/List.vue'),
	},

	{
		path: '/member/account-record/edit/:id',
		name: '會員管理-點數表單',
		layout: "custom",
		id: "ENT_MEMBER_ACCOUNT_RECORD_EDIT",
		component: () => import('../views/admin/MemberAccountRecord/AddOrEdit.vue'),
	},
	//客戶余額轉讓
	{
		path: '/member/account-transfer',
		name: '會員管理-點數轉讓',
		layout: "custom",
		id: "ENT_MEMBER_TRANSFER_LOGS_LIST",
		component: () => import('../views/admin/MemberAccountTransfer/List.vue'),
	},
	{
		path: '/member/black',
		name: '會員管理-黑名單',
		layout: "custom",
		id: "ENT_BLACK_LIST",
		component: () => import('../views/admin/MemberBlack/List.vue'),
	},
	{
		path: '/member/black/add',
		name: '會員管理-黑名單添加',
		layout: "custom",
		id: "ENT_BLACK_ADD",
		component: () => import('../views/admin/MemberBlack/AddOrEdit.vue'),
	},
	//個人信息編輯
	{
		path: '/current/user',
		name: '個人設置',
		layout: "custom",
		id:"ENT_C_USERINFO",
		component: () => import('../views/admin/System/Security/Current/Form.vue'),
	},

]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

export default router
